module.exports = __webpack_public_path__ + "img/7.a255d3a2.png";